import React, { useState } from "react";
import Table from "components/Table";
import {
  BLOCK_FETCH_URL,
  DIVISION_FETCH_URL,
  ESTATE_FETCH_URL,
  REGION_FETCH_URL,
  ROLES_URL,
  ZONE_FETCH_URL,
} from "configs/constants";

import Filter from "@Components/Filter";
import { COMPANY_FETCH_URL } from "configs/constants";

const model = [
  { id: "employee_id", label: "Employee ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "status", label: "Status", type: "string" },
  { id: "id_number", label: "ID Number", type: "string" },
  { id: "created_by", label: "Created By", type: "string" },
  { id: "created_at", label: "Created Date", type: "string" },
  { id: "approved_rejected_by", label: "Approved/Rejected By", type: "string" },
];

const urls = {
  proxyURL: "user/mixed-profiles/",
  exportURL: "user/mixed-profiles/export/",
};

const filterInitialValues = {
  employee_id: "",
  name: "",
  mobile_number: "",
  id_number: "",
  company: "",
  zone: "",
  region: "",
  estate: "",
  division: "",
  block: "",
};
const getCompanyValues = (e, setDisableZone) => {
  if (!e || e.length === 0) {
    setDisableZone(true);
  }
  else {
    setDisableZone(false);
  }

};
const getZoneValues = (e,setDisableRegion) => {
  if (!e || e.length === 0) {
    setDisableRegion(true);
  }
  else {
    setDisableRegion(false);
  }
  
};
const getRegionValues = (e,setDisableEstate) => {
  if (!e || e.length === 0) {
    setDisableEstate(true);
  }
  else {
    setDisableEstate(false);
  }
  
};

const getEstateValues = (e,setDisableDivision) => {
  if (!e || e.length === 0) {
    setDisableDivision(true);
  }
  else {
    setDisableDivision(false);
  }
  
};
const getDivisonValues = (e,setDisableBlock) => {
  if (!e || e.length === 0) {
    setDisableBlock(true);
  }
  else {
    setDisableBlock(false);
  }
  
};
const pageNumberDropdown = true;


const ApprovedAndRejectedProfile = () => {
  // const [roles, setRoles] = useState([]);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const [filterValues, setFilterValues] = useState({});
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [disableZone, setDisableZone] = useState(true);


  const filterFields = [
    {
      type: "input",
      name: "employee_id",
      label: "Employee ID",
    },
    {
      type: "input",
      label: "Name",
      name: "name",
    },
    {
      type: "input",
      label: "Mobile Number",
      name: "mobile_number",
    },
    {
      type: "input",
      label: "ID Number",
      name: "id_number",
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
  
  
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      disabled:disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      paginated: true,
      disabled:disableEstate,
      getValue: (e) => getEstateValues(e, setDisableDivision),

      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      disabled:disableDivision,
      getValue: (e) => getDivisonValues(e, setDisableBlock),

      optionsDependsOn: "estate",
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      disabled:disableBlock,

      optionsDependsOn: "division",
    },
    {
      type: "reactselect",
      name: "role",
      label: "Role",
      proxyUrl: ROLES_URL,
      paginated: false,
      isPaginationEnabled: false,
      discardOptionsByProperties: {
        keys: ["mobile_access"],
        values: [false],
      },
    },
    {
      type: "reactselect",
      label: "Status",
      name: "status",
      outerOptions: [
        { id: "Approved", name: "Approved" },
        { id: "Rejected", name: "Rejected" },
      ],
    },
  ];


  // useEffect(() => {
  //   fetchDataFromApi(ROLES_URL, setRoles, true);
  // }, []);
  //
  // useEffect(() => {
  //   const role_without_mobile_access = roles.find(
  //     (role) => role.mobile_access === false
  //   );
  //
  //   if (roles.includes(role_without_mobile_access)) {
  //     const roles_with_mobile_access = roles.filter(
  //       (item) => item.mobile_access === true
  //     );
  //     setRoles(roles_with_mobile_access);
  //   }
  // }, [roles]);

  const onFilterRequest = (values) => {
    setFiltersApplied(true); 

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };
  const clearFilter =()=>{
    filterInitialValues.status = null
    window.location.reload();
   }


  return (
    <>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
        onClear={clearFilter}


      />
      {filtersApplied ? ( 

      <Table
        proxyURL={urls.proxyURL}
        excelExport={{ fileName: "Approved-Rejected-Profile-Update" }}
        model={model}
        noFilter
        noAddButton
        filterValues={filterValues}
        pageNumberDropdown={pageNumberDropdown}

      />
      ) : (
        <Table
        proxyURL={null}
        excelExport
        model={model}
        noFilter
        noAddButton
        filterValues={filterValues}
        pageNumberDropdown={pageNumberDropdown}

      />
      )}

    </>
  );
};

export default ApprovedAndRejectedProfile;
